// NOTE: This file is maintained in the parent project AS Common.
//       Your application should avoid modifying this file.

import { AlertsProvider, Theme, useAuth, UsersProvider, Page } from "common";
import { CssBaseline as MuiCssBaseline } from "@mui/material";
import { ThemeProvider as MuiThemeProvider } from "@mui/material/styles";
import { BrowserRouter } from "react-router";
import { App } from "app/App";

export const AppRoot = () => {
  const auth = useAuth();

  return (
    <>
      {(process.env.REACT_APP_ENVIRONMENT === "test" ||
        auth.isAuthenticated) && (
        <MuiThemeProvider theme={Theme}>
          <MuiCssBaseline />
          <BrowserRouter>
            <AlertsProvider>
              <UsersProvider>
                <Page>
                  <App />
                </Page>
              </UsersProvider>
            </AlertsProvider>
          </BrowserRouter>
        </MuiThemeProvider>
      )}
    </>
  );
};
